import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  toggleCartModalVisibility,
  toggleGlobalSearchVisibility,
  toggleNavigationVisibility
} from '../../store/modules/interfaces/actions';

export const Navigation = (Component) => (props) => (
  <Component {...props} />
);

const mapStateToProps = (state) => ({
  cartCount: state.cart.count,
  currency: state.geo.currency,
  locale: state.geo.locale,
  isCartActive: state.interfaces.isCartActive,
  isGlobalSearchActive: state.interfaces.isGlobalSearchActive,
  isNavigationActive: state.interfaces.isNavigationActive,
  profileId: state.profile.id,
  profileEmail: state.profile.email,
  profileFirstName: state.profile.first_name
});

const mapDispatchToProps = (dispatch) => ({
  toggleCartModal: (isActive) => dispatch(toggleCartModalVisibility(isActive)),
  toggleGlobalSearch: (isActive) => dispatch(toggleGlobalSearchVisibility(isActive)),
  toggleNavigation: (isActive) => dispatch(toggleNavigationVisibility(isActive))
});

const composedNavigationWrapper = compose(
  connect(mapStateToProps, mapDispatchToProps),
  Navigation
);

export default composedNavigationWrapper;
